module.exports = __webpack_public_path__ + "img/open_dialog_mobile.f7f9cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/open_dialog_mobile.png
// module id = PHVM
// module chunks = 0